import React from 'react';
import PropTypes from 'prop-types';
import { ProjectTilesHeaderContainer } from './ProjectTilesHeader.css';
import Title from '../Title/Title';
import Text from '../Text/Text';

const ProjectTilesHeader = ({
  numberOfProjects,
  selectedCountry,
  query,
  selectedService,
}) => {
  return numberOfProjects > 0 ? (
    <ProjectTilesHeaderContainer>
      <div className='ProjectTilesHeader__Top'>
        <Text type={'quaternary'}>
          {selectedService
            ? query.selection_tile_label_service.text
            : query.selection_tile_label_country.text}
        </Text>
        <Text type={'quaternary'}>
          {query.selection_tile_label_per_country.text}
        </Text>
      </div>
      <div className='ProjectTilesHeader__Bottom'>
        <Title as='h3' type='h2' customClassName='ProjectTilesHeader__Title'>
          {selectedCountry
            ? selectedCountry
            : selectedService
            ? selectedService
            : query.all_label.text}
        </Title>
        <Title
          customStyle={{ whiteSpace: 'nowrap' }}
          as='span'
          type='h2'
          customClassName='ProjectTilesHeader__Count'
        >
          {numberOfProjects}
        </Title>
      </div>
    </ProjectTilesHeaderContainer>
  ) : <></>; 
};

ProjectTilesHeader.propTypes = {
  query: PropTypes.object.isRequired,
  selectedCountry: PropTypes.any,
};

export default ProjectTilesHeader;
